import apiClient from './api';

/**
 * Servicio para gestionar las claves de respuesta del Test de Raven
 * Las claves contienen las respuestas correctas oficiales del Test de Matrices Progresivas
 */
export const ravenClavesService = {
  /**
   * Claves de respuesta oficiales del Test de Raven
   * Cada entrada tiene: preguntaId, opcionCorrectaId
   * Test de Raven con 12 preguntas, cada una con 8 opciones
   */
  clavesRaven: {
    // Test Raven - Claves oficiales (12 preguntas)
    1: 1,   // Pregunta 1 → Opción 1
    2: 7,   // Pregunta 2 → Opción 7
    3: 8,   // Pregunta 3 → Opción 8
    4: 5,   // Pregunta 4 → Opción 5
    5: 5,   // Pregunta 5 → Opción 5
    6: 7,   // Pregunta 6 → Opción 7
    7: 6,   // Pregunta 7 → Opción 6
    8: 8,   // Pregunta 8 → Opción 8
    9: 1,   // Pregunta 9 → Opción 1
    10: 1,  // Pregunta 10 → Opción 1
    11: 6,  // Pregunta 11 → Opción 6
    12: 3   // Pregunta 12 → Opción 3
  },

  /**
   * Verificar si una respuesta es correcta para una pregunta específica
   * @param {number} preguntaId - ID de la pregunta
   * @param {number} opcionId - ID de la opción seleccionada
   * @returns {boolean} true si es correcta, false si no
   */
  verificarRespuesta: (preguntaId, opcionId) => {
    const respuestaCorrecta = ravenClavesService.clavesRaven[preguntaId];
    return respuestaCorrecta === opcionId;
  },

  /**
   * Obtener la respuesta correcta para una pregunta específica
   * @param {number} preguntaId - ID de la pregunta
   * @returns {number|null} ID de la opción correcta o null si no existe
   */
  obtenerRespuestaCorrecta: (preguntaId) => {
    return ravenClavesService.clavesRaven[preguntaId] || null;
  },

  /**
   * Obtener todas las claves de respuesta
   * @returns {Object} Objeto con todas las claves preguntaId -> opcionCorrectaId
   */
  obtenerTodasLasClaves: () => {
    return { ...ravenClavesService.clavesRaven };
  },

  /**
   * Verificar si una pregunta tiene clave registrada
   * @param {number} preguntaId - ID de la pregunta
   * @returns {boolean} true si tiene clave, false si no
   */
  tieneClaveRegistrada: (preguntaId) => {
    return preguntaId in ravenClavesService.clavesRaven;
  }
};

export default ravenClavesService;